module.exports = __webpack_public_path__ + "static/media/noPhoto.5fff1b0c.png";